import { FMS_ID } from './billing-definitions';

/**
 * Replaced by hierarchical FMS_ID.
 * Existing code using MeteringEventType should migrate to FMS_ID.
 */
export type MeteringEventType = FMS_ID;

/**
 * System-wide event identifiers.
 * Mapping legacy constants to the new hierarchical FMS_ID strings.
 * This registry provides a single place for commonly used identifiers 
 * to avoid magic strings while maintaining type safety via FMS_ID.
 */
export const MeteringEventTypes = {
  // IoT / Monitoring
  IOT_MEASUREMENT_CREATED: 'monitoring.create_measurement' as FMS_ID,
  IOT_DATAPOINT_INGESTED:  'monitoring.ingest_datapoint' as FMS_ID,
  IOT_DEVICE_RENTAL_DAY:   'monitoring.device_rental_day' as FMS_ID,
  IOT_DEVICE_REGISTERED:   'monitoring.device.registered' as FMS_ID,

  // Analytics & QC
  QC_POUR_CREATED:  'analytics.create_pour' as FMS_ID,
  QC_LOT_CREATED:   'analytics.create_lot' as FMS_ID,
  ANALYTICS_OCR_JOB_CREATED: 'analytics.ocr_job' as FMS_ID,
  ANALYTICS_OCR_STR_CREATED: 'analytics.ocr_job.strengt_test_results' as FMS_ID,
  ANALYTICS_OCR_DELIVERY_NOTE_CREATED: 'analytics.ocr_job.pour' as FMS_ID,

  // Simulations
  SIMULATIONS_RUN: 'simulations.run_simulation' as FMS_ID,

  // Project System Events
  PROJECT_MODULE_LOCKED: 'project.module.locked' as FMS_ID,
  PROJECT_TRIAL_EXPIRED: 'project.trial.expired' as FMS_ID,
  
  // Platform Events
  PLATFORM_SIGN_UP: 'platform.sign_up.new_user' as FMS_ID,
  
  // Backward compatibility
  PLATFORM_MODULE_LOCKED: 'project.module.locked' as FMS_ID,
  PLATFORM_TRIAL_EXPIRED: 'project.trial.expired' as FMS_ID,
} as const;

/**
 * FEATURE_METRIC_MAP is deprecated in favor of direct hierarchical string matching.
 */
export const FEATURE_METRIC_MAP: Record<string, string> = {}; 
